import { z } from "zod";

export const researchAreaSchema = z.object({
  id: z.string().optional(),
  title: z.string().min(1, "Area title is required").max(300, "Title too long"),
  description: z.string().max(2000, "Description too long").optional().nullable(),
  keywords: z
    .array(z.string().max(100, "Keyword too long"))
    .max(20, "Maximum 20 keywords per area")
    .optional(),
  icon: z.string().max(50, "Icon identifier too long").optional().nullable(),
});

export type ResearchArea = z.infer<typeof researchAreaSchema>;


import { getSectionDisplayOptionsSchema } from "../display-options";

export const researchDisplayOptionsSchema = getSectionDisplayOptionsSchema("research");
export type ResearchDisplayOptions = z.infer<typeof researchDisplayOptionsSchema>;

export const researchContentSchema = z.object({
  heading: z.string().max(200).default("Research Interests").optional(),
  summary: z.string().max(5000, "Summary too long").optional().nullable(),
  areas: z.array(researchAreaSchema).max(30, "Maximum 30 research areas allowed"),
  displayOptions: researchDisplayOptionsSchema.optional(),
});

export type ResearchContent = z.infer<typeof researchContentSchema>;
